import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";
import { FormikProps, getIn } from "formik";
import _ from "lodash";

import Select from "components/Select";

import { ITransactionValuesForm } from "entities/Deal/sdk";

export interface ITransactionSelectField {
  formik: FormikProps<ITransactionValuesForm>;
  fieldName: string;
  inputLabel: string;
  options: Array<{ value: string; label: string }>;
  showWarning?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
}

const TransactionSelectField = ({
  formik,
  options,
  fieldName,
  inputLabel,
  showWarning,
  disabled = false,
  onChange,
  sx,
}: ITransactionSelectField) => (
  <Select
    {...formik.getFieldProps(fieldName)}
    sx={{ ...sx }}
    inputLabel={inputLabel}
    error={
      showWarning ||
      (getIn(formik.touched, fieldName) &&
        !_.isNil(getIn(formik.errors, fieldName)))
    }
    helperText={
      showWarning
        ? "Changing the transaction type will erase all filled out information in the next section!"
        : getIn(formik.touched, fieldName) &&
          !_.isNil(getIn(formik.errors, fieldName)) &&
          getIn(formik.errors, fieldName)
    }
    options={options}
    InputLabelProps={{ shrink: true }}
    disabled={disabled}
    onChange={
      !_.isNil(onChange) ? onChange : formik.getFieldProps(fieldName).onChange
    }
  />
);

export default TransactionSelectField;
